import React from 'react';
import { ContractTextInput, ContractSelectGroup } from './ContractFields';
import { formatFutureFixingDate, nextFutureFixingDate } from 'contracts/contractUtils';
import { IField } from 'components/shared/form/IField';
import { usePriceContext } from 'contracts/utils/priceContext';

export interface DifferentialPriceFieldsProps {
  futurePriceFixingDateField?: IField;
  fixationRightsField?: IField;
  shipmentDate: Date;
}
const DifferentialPriceFields = ({
  futurePriceFixingDateField,
  fixationRightsField,
  shipmentDate,
}: DifferentialPriceFieldsProps) => {
  const { differentialPrice, opportunityPrice } = usePriceContext();

  return (
    <>
      <ContractTextInput
        field={differentialPrice?.field}
        value={differentialPrice?.value}
        onChange={differentialPrice?.set}
        type='number'
        step='0.0001'
        min='0.0001'
        append='USD/lb'
      />

      <ContractTextInput
        field={futurePriceFixingDateField}
        onChange={() => true}
        value={formatFutureFixingDate(nextFutureFixingDate(shipmentDate, false))}
      />
      <ContractSelectGroup
        field={fixationRightsField}
        value={fixationRightsField?.value}
        placeholder={false}
      />
      {opportunityPrice && (
        <ContractTextInput field={opportunityPrice.field}></ContractTextInput>
      )}
    </>
  );
};

export default DifferentialPriceFields;
